import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {BillingParty} from '../../../graphql/billing_party.datatypes';
import {gqlBillingParty} from './getBillingParties.api';

interface BillingPartiesData {
    myBillingParties?: void,
    billingParties?: void,
    billingPartiesInMyGroup: {
        data: BillingParty[],
        paginatorInfo: PaginatiorInfo,
    }
}

const GET_BILLING_PARTIES_QUERY = gql`
  query getBillingPartiesInMyGroup($groupRef: String!, $count: Int!, $page: Int!, $where: WhereConditions, $hasGroupBooking: QueryBillingPartiesInMyGroupHasGroupBookingWhereHasConditions, $hasBillingPartyMember: QueryBillingPartiesInMyGroupHasBillingPartyMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    billingPartiesInMyGroup(groupRef: $groupRef, first: $count, page: $page, where: $where, hasGroupBooking: $hasGroupBooking, hasBillingPartyMember: $hasBillingPartyMember, orderBy: $orderBy){
      data {
        ${gqlBillingParty}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

const getBillingPartiesInMyGroup = (groupRef: string, count: number, page: number, where?: any, orderBy?: any, hasGroupBooking?: any, hasBillingPartyMember?: any) => useQuery<BillingPartiesData>(
    GET_BILLING_PARTIES_QUERY,
    {
        variables: {
            groupRef,
            count,
            page,
            where,
            hasGroupBooking,
            hasBillingPartyMember,
            orderBy,
        },
    }
);

export default getBillingPartiesInMyGroup;
